// extracted by mini-css-extract-plugin
module.exports = {"container":"SpriteFrame_container__2_uJi"};